import { EmbedVersion } from './getEmbedCode.types';
import getJsFormsUrl from 'forms-utils-lib/urls/public/getJsFormsUrl';
const ScriptPath = {
  [EmbedVersion.NEXT]: '/forms/v2.js',
  [EmbedVersion.V2_PRERELEASE]: '/forms/v2.js?pre=1',
  [EmbedVersion.V2]: '/forms/embed/v2.js',
  [EmbedVersion.V3]: '/forms/embed/v3.js'
};
const formatContext = context => JSON.stringify(context, null, 4).replace(/{|}/gm, '').replace(new RegExp(`"(${Object.keys(context).join('|')})":`, 'g'), '$1:');
const getEmbedCode = (context, {
  domain,
  version
} = {
  domain: '',
  version: EmbedVersion.NEXT
}) => {
  const scriptVersion = version || EmbedVersion.NEXT;
  const scriptDomain = domain || getJsFormsUrl().replace('https:', '');
  const path = ScriptPath[scriptVersion];
  return `<script charset="utf-8" type="text/javascript" src="${scriptDomain}${path}"></script>
<script>
  hbspt.forms.create({${formatContext(context)}  });
</script>`;
};
export default getEmbedCode;